import { createContext, FC, ReactNode, useContext, useState } from 'react';

interface ChartContextType {
  zoom: number | undefined;
  setZoom: React.Dispatch<React.SetStateAction<number | undefined>>;
}

const ChartContext = createContext<ChartContextType | undefined>(undefined);

interface ChartContextProviderProps {
  children: ReactNode;
}

const ChartProvider: FC<ChartContextProviderProps> = ({ children }) => {
  const [zoom, setZoom] = useState<number | undefined>(undefined);

  return <ChartContext.Provider value={{ zoom, setZoom }}>{children}</ChartContext.Provider>;
};

export const useChartContext = () => useContext(ChartContext);

export default ChartProvider;
